// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./LastFixturePlayerStats.scss');

// Assets
var spinner = require('../../common/images/Rolling.svg');

// Components
var DefenderStats = require('./DefenderStats');
var GoalkeeperStats = require('./GoalkeeperStats');
var MidfielderStats = require('./MidfielderStats');
var StrikerStats = require('./StrikerStats');

class LastFixturePlayerStatsModule extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            allStats: {},
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadStats();
    }

    loadStats = () => {
        $.ajax({
            method: "GET", 
            url: this.props.data.endpoint
        })
        .done(data => {
            this.populateStats(data);
        })
        .always(() => {
            this.hideLoader();
        });
    };

    populateStats = (data) => {
        this.setState(prevState => {
            const updatedStats = { ...prevState.allStats, ...data };

            // Check if the position is "Substitute"
            if (updatedStats.position === "Substitute") {
                // Update the substitute position to be the one coming from Umbraco
                // passed in via a prop on the ReactModel (Which is their usual position they play, stored in the cms)
                // We can then map/show the correct stats for them even if 0 values if they didn't play
                updatedStats.position = this.props.data.playerPosition;
            }            

            // Return the updated state
            return { allStats: updatedStats };
        });
    };
    hideLoader = () => {
        this.setState({ isLoading: false });
    };

	render() {
        return (
            <div className="LastFixturePlayerStats">
                <div className="LastFixturePlayerStats__container">
                    {this.state.allStats && this.state.allStats.stats &&
                        <h2>Last Match Stats</h2>
                    }
                    {this.state.allStats && this.state.allStats.position === "Defender" &&
                        <DefenderStats {...this.state.allStats.stats} />
                    }

                    {this.state.allStats && this.state.allStats.position === "Goalkeeper" &&
                        <GoalkeeperStats {...this.state.allStats.stats} />
                    }

                    {this.state.allStats && this.state.allStats.position === "Midfielder" &&
                        <MidfielderStats {...this.state.allStats.stats} />
                    }

                    {this.state.allStats && this.state.allStats.position === "Striker" &&
                        <StrikerStats {...this.state.allStats.stats} />
                    }

                    {!this.state.isLoading && Object.keys(this.state.allStats).length === 0 &&
                        <p>Stats unavailable</p>
                    }
                </div>

                {this.state.isLoading &&
                    <img src={spinner} className="spinner" alt="Loading..." />
                }
            </div>
        )
    }
}

module.exports = LastFixturePlayerStatsModule;


// WEBPACK FOOTER //
// ./src/components/LastFixturePlayerStats/LastFixturePlayerStatsModule.js